/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MensalidadeObservacoesAliases {
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FORM_OBS = 'form-obs',
  PANEL_OBS = 'panel-obs',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
}
export { MensalidadeObservacoesAliases };
